/**
 * md-versand.js v1.5 (2026-09-14) — Google-Versandpreis: Markierung der Besucher aus Google-PRODUKTANZEIGEN fuer
 * den Carrier Service "versand-rates" (Supabase). Kein Netzaufruf an fremde Dienste, keine Abhaengigkeit im
 * Seitenaufbau.
 *
 * Ablauf:
 *  1. Kommt der Besucher mit utm_medium=product_sync in der URL (Nutzer-Vorgabe 12.09.2026: nur Produktanzeigen;
 *     das ist der Parameter, den der Google-Kanal an die Produktlinks des Feeds haengt), setzt das Skript das
 *     Erstanbieter-Cookie MD_VK_COOKIE (48 Stunden, Nutzer-Vorgabe 12.09.; v1 hatte 30 Tage). Andere Google-Parameter (gclid, srsltid)
 *     markieren NICHT (v1 tat das noch).
 *  2. Solange das Cookie steht, bekommt jede Add-to-Cart-Form ein verstecktes Feld properties[_vk]=g
 *     (Unterstrich-Properties zeigt weder Warenkorb noch Checkout an). Die Zeile traegt damit den Marker,
 *     den Shopify in der Rate-Anfrage an den Carrier Service mitschickt.
 *  3. Zeilen, die schon VOR der Markierung im Korb lagen (oder per Quick-Add ohne Form kamen), werden einmal
 *     je Seite ueber /cart/change.js nachmarkiert (bestehende Properties UND Menge bleiben erhalten; v1.4).
 *     v1.5: nur die erste Zeile liest /cart.js, danach dient die change.js-Antwort als frischer Cart (n+1 statt 2n Requests).
 *
 * Ausfallsicherheit: Faellt irgendetwas hier aus, fehlt nur der Marker -> Shopify zeigt die normale Rate.
 * Nichts blockiert Seite oder Checkout; alle Aufrufe laufen nach dem Laden und asynchron.
 */
(function () {
  'use strict';
  var MD_VK_COOKIE = '_mdzo_vk';
  var MD_VK_WERT = 'g';
  var MD_VK_TAGE = 2; // v1.2 (12.09.2026, Nutzer-Vorgabe): 48 Stunden statt 30 Tage
  var MARKER_PARAM = 'utm_medium';
  var MARKER_WERT = 'product_sync';
  var routes = (window.theme && window.theme.routes) || {};
  var CART_JS = (routes.cart || '/cart') + '.js';
  var CART_CHANGE = routes.cartChange || '/cart/change.js';

  function getCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    return parts.length === 2 ? decodeURIComponent(parts.pop().split(';').shift()) : '';
  }
  function setCookie(name, wert, tage) {
    var d = new Date(); d.setTime(d.getTime() + tage * 864e5);
    document.cookie = name + '=' + encodeURIComponent(wert) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function hatGoogleParam() {
    try { return new URLSearchParams(location.search).get(MARKER_PARAM) === MARKER_WERT; } catch (e) { return false; }
  }
  function markiert() { return getCookie(MD_VK_COOKIE) === MD_VK_WERT; }

  // 1. Markierung setzen (auch verlaengern, wenn der Besucher erneut ueber Google kommt)
  if (hatGoogleParam()) { try { setCookie(MD_VK_COOKIE, MD_VK_WERT, MD_VK_TAGE); } catch (e) {} }
  if (!markiert()) return;

  // 2. Verstecktes Feld in jede Add-to-Cart-Form: beim Laden vorhandene Forms plus Absende-Zeitpunkt (Capture,
  //    laeuft vor dem Submit-Handler des Themes, der die FormData daraus baut).
  function feldSichern(form) {
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.querySelector('input[name="properties[_vk]"]')) return;
    var inp = document.createElement('input');
    inp.type = 'hidden'; inp.name = 'properties[_vk]'; inp.value = MD_VK_WERT;
    form.appendChild(inp);
  }
  function alleFormsSichern() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) feldSichern(forms[i]);
  }
  document.addEventListener('submit', function (ev) { try { feldSichern(ev.target); } catch (e) {} }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleFormsSichern); else alleFormsSichern();

  // 3. Bestehende Zeilen ohne Marker nachmarkieren — einmal je Seite, im Leerlauf, nacheinander.
  var nachmarkiertLaeuft = false;
  function nachmarkieren(cart) {
    if (nachmarkiertLaeuft) return; nachmarkiertLaeuft = true;
    var holen = cart ? Promise.resolve(cart) : fetch(CART_JS, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    holen.then(function (c) {
      var items = (c && c.items) || []; var offen = [];
      for (var i = 0; i < items.length; i++) {
        var p = items[i].properties || {};
        if (p._vk !== MD_VK_WERT) offen.push({ key: items[i].key, props: p });
      }
      var kette = Promise.resolve(); var zuletzt = null; // v1.5: Antwort von change.js = frischer Cart fuer die naechste Zeile
      offen.forEach(function (z) {
        kette = kette.then(function () {
          // v1.4 (13.09.2026): change.js OHNE quantity setzt die Menge auf 1 zurueck (gemessen: 3 -> 1). Deshalb die
          // Zeile direkt vorher frisch lesen und Menge + aktuelle Properties mitsenden; weg/0/schon markiert -> auslassen.
          return (zuletzt ? Promise.resolve(zuletzt) : fetch(CART_JS, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); })).then(function (akt) {
            var li = (akt && akt.items) || []; var zeile = null;
            for (var j = 0; j < li.length; j++) if (li[j].key === z.key) { zeile = li[j]; break; }
            if (!zeile || !(zeile.quantity > 0)) return;
            var alt = zeile.properties || {};
            if (alt._vk === MD_VK_WERT) return;
            var props = {}; for (var k in alt) if (Object.prototype.hasOwnProperty.call(alt, k)) props[k] = alt[k];
            props._vk = MD_VK_WERT;
            return fetch(CART_CHANGE, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: z.key, quantity: zeile.quantity, properties: props }) })
              .then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { if (c && c.items) zuletzt = c; });
          }).then(function () {}, function () {});
        });
      });
      return kette;
    }).catch(function () {}).then(function () { nachmarkiertLaeuft = false; });
  }
  function imLeerlauf(fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 3000 }); else setTimeout(fn, 1500); }
  // v1.3: nur wenn ein Warenkorb existiert (Shopify setzt das Cookie 'cart' erst mit der ersten Position) —
  //       spart den /cart.js-Aufruf auf jeder Seite fuer markierte Besucher mit leerem Korb.
  function korbLeer() {
    // Das Theme rendert #cart-icon-bubble serverseitig LEER, solange der Korb keine Position hat; ohne Bubble
    // entscheidet das Shopify-Cookie 'cart' (existiert erst nach der ersten Korb-Interaktion).
    var b = document.getElementById('cart-icon-bubble');
    if (b) return b.textContent.trim() === '';
    return !getCookie('cart');
  }
  window.addEventListener('load', function () { if (!korbLeer()) imLeerlauf(function () { nachmarkieren(null); }); });
  // Nach jedem Add: Zeilen ohne Marker (z. B. Quick-Add ohne Form) nachziehen; das Theme liefert das Cart-JSON mit.
  document.addEventListener('on:cart:add', function (ev) { try { var c = ev.detail && ev.detail.cart; imLeerlauf(function () { nachmarkieren(c || null); }); } catch (e) {} });

  // 4. v1.2: Versand-Overlay (Shopify-Versandrichtlinie im Fenster #md-shipping-modal und auf der Richtlinienseite):
  //    Zeile "Deutschland" auf den Google-Preis setzen. Betrag/Beschreibung kommen vom oeffentlichen Anzeige-Endpunkt
  //    der Function (nur Anzeige-Daten, kein Secret) und liegen 10 Minuten im sessionStorage. Schlaegt der Abruf fehl,
  //    bleibt der normale Preis stehen (nie ein falsches Versprechen nach unten, nie eine Blockade).
  var ANZEIGE_URL = 'https://dxgoxjkelehfrjxfhdwm.supabase.co/functions/v1/versand-rates/mundizio/anzeige';
  var ANZEIGE_KEY = 'md_versand_anzeige';
  var anzeigeLaufend = null;
  function anzeigeLaden() {
    if (anzeigeLaufend) return anzeigeLaufend;
    try {
      var c = JSON.parse(sessionStorage.getItem(ANZEIGE_KEY) || 'null');
      if (c && c.bis > Date.now()) return Promise.resolve(c.wert);
    } catch (e) {}
    anzeigeLaufend = fetch(ANZEIGE_URL, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (a) {
      try { sessionStorage.setItem(ANZEIGE_KEY, JSON.stringify({ bis: Date.now() + 600000, wert: a })); } catch (e) {}
      return a;
    }).catch(function () { return null; });
    return anzeigeLaufend;
  }
  var OVERLAY_SELEKTOR = '#md-shipping-modal, .md-shipping-modal, .shopify-policy__body';
  function overlayPatchen(a) {
    if (!a || !a.aktiv || typeof a.cents !== 'number') return;
    var preis = (a.cents / 100).toFixed(2).replace('.', ',') + ' €';
    var wurzeln = document.querySelectorAll(OVERLAY_SELEKTOR);
    for (var w = 0; w < wurzeln.length; w++) {
      var strongs = wurzeln[w].querySelectorAll('strong');
      for (var i = 0; i < strongs.length; i++) {
        if (strongs[i].textContent.trim() !== 'Deutschland') continue;
        var zeile = strongs[i].parentElement;
        if (!zeile || zeile.getAttribute('data-md-versand') === 'g') continue;
        var spans = zeile.querySelectorAll('span');
        if (!spans.length) continue;
        spans[0].textContent = preis;
        if (spans[1] && a.beschreibung) spans[1].textContent = a.beschreibung;
        zeile.setAttribute('data-md-versand', 'g');
      }
    }
  }
  // v1.3: nur auf Seiten, die das Overlay oder die Richtlinie ueberhaupt rendern (Produktseite, Richtlinienseite).
  function overlayAbgleichen() { if (document.querySelector(OVERLAY_SELEKTOR)) anzeigeLaden().then(overlayPatchen); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', overlayAbgleichen); else overlayAbgleichen();
  window.addEventListener('load', function () { imLeerlauf(overlayAbgleichen); });
})();
